import { render, staticRenderFns } from "./WorkPlans.vue?vue&type=template&id=51b81fb8&scoped=true&"
import script from "./WorkPlans.vue?vue&type=script&lang=js&"
export * from "./WorkPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b81fb8",
  null
  
)

export default component.exports